import styled, { withTheme } from 'styled-components'
import { Flex } from 'rebass'
import media from '../../../utils/style'

const SearchGroupResultRow = styled(Flex)`
  text-align: left;
  align-items: center;
  justify-content: center;
  line-height: 1.3;
  border-top: 1px ${(props) => props.theme.colors.grey_op10} solid;
  cursor: pointer;
  transition: background-color 0.5s ${(props) => props.theme.ease.ease_out_expo};

  svg path {
    fill: ${(props) => props.theme.colors.blue};
  }

  ${media.LargeScreenUp`
    &:hover {
      svg path {
        fill: ${(props) => props.theme.colors.blue};
      }
      color: ${(props) => props.theme.colors.blue};
      background-color: ${(props) => props.theme.colors.blue_op20};
      border-bottom-color: ${(props) => props.theme.colors.blue_op20};
    }
  `};

  &:first-child {
    border-bottom: none;
  }

  & > div:last-child {
    text-align: center;
    ${media.LargeScreenUp`
      text-align: right;
    `};
  }
`

export default withTheme(SearchGroupResultRow)
